import { format } from 'date-fns';

export const createBaseDate = (): Date => {
  const baseDate = new Date();
  baseDate.setSeconds(0, 0);
  return baseDate;
};

export const createStartOfDay = (baseDate: Date): Date => {
  const startOfDay = new Date(baseDate);
  startOfDay.setHours(0, 0);
  return startOfDay;
};

export const createEndOfDay = (baseDate: Date): Date => {
  const endOfDay = new Date(baseDate);
  endOfDay.setHours(24, 0);
  return endOfDay;
};

export const formatTime = (date: Date): string => {
  if (
    (date.getHours() === 0 || date.getHours() === 24) &&
    date.getMinutes() === 0
  ) {
    return '12:00 AM';
  }
  return format(date, 'h:mm aaa');
};

export const stringToDate = (time: string, baseDate: Date): Date => {
  if (!time) return new Date();
  const [hour, minute] = time.split(':').map(Number);
  const date = new Date(baseDate);
  if (hour === 24) {
    date.setHours(0, minute);
    date.setDate(date.getDate() + 1);
  } else {
    date.setHours(hour, minute);
  }
  return date;
};

export const dateToString = (date: Date, baseDate: Date): string => {
  return date.getHours() === 0 &&
    date.getMinutes() === 0 &&
    date.getDate() !== baseDate.getDate()
    ? '24:00'
    : format(date, 'HH:mm');
};

export const compareTimeStrings = (
  time1: string,
  time2: string,
  isEndTime2 = false,
): number => {
  if (isEndTime2 && time2 === '00:00') {
    time2 = '24:00';
  }
  return time1.localeCompare(time2);
};

export const getMinEndTime = (startTime: string, baseDate: Date): Date => {
  const startDate = stringToDate(startTime, baseDate);
  const minEndDate = new Date(startDate.getTime() + 5 * 60 * 1000);
  return minEndDate;
};
